// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M9.5 13H14.5V22H9.5V13Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M13 2H22V22H16.5V11H13V2Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M2 2H11V11H7.5V22H2V2Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-dam-4-filled')
export default class Dam4FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'dam-4-filled',
    }
  }
}
